import * as React from 'react';
import { withFormik, FormikBag } from 'formik';
import { DealRentTrap, IFormValues, TDealRentTrapOfertaFormikProps, IDealRentTrapProps } from './DealRentTrap';
import { withProvider } from '../../redux';
import { ApplicationContext } from '../ApplicationContext';
import { always } from 'ramda';
import { object, boolean } from 'yup';

export const DealRentTrapContainerWithContext = withProvider(
  (props: TDealRentTrapOfertaFormikProps) => {
    const context = { httpApi: props.httpApi, logger: props.logger, config: props.config };

    return (
      <ApplicationContext.Provider value={context}>
        <DealRentTrap {...props} />
      </ApplicationContext.Provider>
    );
  },
);

export const handleSubmit = (
  values: IFormValues,
  { setSubmitting, props: { applyDealRent } }: FormikBag<IDealRentTrapProps, IFormValues>,
) => {
  setSubmitting(false);
  applyDealRent();
};

export const DealRentTrapContainer = withFormik<IDealRentTrapProps, IFormValues>({
  handleSubmit,
  mapPropsToValues: always({ isTermsAccepted: false }),
  validationSchema: object({
    isTermsAccepted: boolean()
      .oneOf([true], 'Необходимо принять условия оферты')
      .required(),
  }),
})(DealRentTrapContainerWithContext);
